module.exports = {"id":"233411","name":"Claud Adjapong","rating":"71","photo":"./data/images/photos/3/233411.png","club":{"name":"Sassuolo","logo":"./data/images/clubs/Sassuolo.png"},"positions":["MG","MD","DD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ClaudAdjapong0.json
// module id = 821
// module chunks = 0